import styled from '@emotion/styled';
import { getTypographyCss, theme } from '@revenuemarket/design';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
`;

export const SpinnerWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  z-index: 101;
  text-align: center;
`;

export const Bg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  rgba(17, 17, 17, 0.7);
  background: ${theme.colors.grayscale850}B2;
`;

export const Message = styled.div`
  margin-top: 20px;
  text-align: center;
  /* color: #d1d6db; */
  color: ${theme.colors.grayscale250};
  ${getTypographyCss('body1')};
`;
